import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../theme';

/**
 * Custom hook that defines the styles for the comment section component.
 */
const useCommentSectionStyles = makeStyles()(() => ({
  commentSection: {
    fontFamily: theme.fontFamily,
    padding: theme.padding.s,
    borderRadius: theme.borderRadius.s,
    backgroundColor: theme.background.lighter,
    height: '100%',
  },
  toggleButton: {
    'textTransform': 'none',
    'fontFamily': theme.fontFamily,
    'background': 'none',
    'color': theme.primary.light,
    'border': 'none',
    'fontSize': theme.fontSize.default,
    'cursor': 'pointer',
    'padding': `${theme.padding.xs} 0`,
    'display': 'flex',
    'alignItems': 'center',
    'gap': theme.gap.s,
    'minWidth': '180px',
    '&:hover': {
      color: theme.primary.dark,
    },
    '&:active': {
      color: theme.primary.darker,
    },
  },
  commentsContainer: {
    marginTop: theme.margin.s,
  },
  commentsList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  commentItem: {
    fontFamily: theme.fontFamily,
    backgroundColor: theme.background.paper,
    padding: theme.padding.s,
    marginBottom: theme.margin.xs,
    borderRadius: theme.borderRadius.xs,
    border: theme.border,
  },
  commentText: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.smaller,
    marginBottom: theme.margin.xs,
    marginTop: 0,
  },
  commentMeta: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.smallest,
    color: colors.gray['300'],
  },
  addComment: {
    marginTop: theme.margin.m,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.gap.s,
  },
  inputRow: {
    display: 'flex',
    gap: theme.gap.s,
  },
  commentTextarea: {
    maxWidth: 'none',
    fontFamily: theme.fontFamily,
    flex: 5,
    height: '40px',
    fontSize: theme.fontSize.smaller,
    resize: 'none',
  },
  addCommentButton: {
    'backgroundColor': colors.green[400],
    'border': `1px solid ${colors.green[400]}`,
    'marginLeft': 0,
    'marginRight': 0,
    '&:hover': {
      backgroundColor: colors.green[500],
      borderColor: colors.green[500],
    },
    '&:active': {
      backgroundColor: colors.green[600],
      boxShadow: theme.buttonShadow(colors.green[600]),
      borderColor: colors.green[600],
    },
  },
  error: {
    marginTop: '-0.5em',
    marginBottom: 0,
  },
  commentAuthor: {
    'fontFamily': theme.fontFamily,
    'fontSize': theme.fontSize.smallest,
    'color': colors.purple['500'],
    'fontWeight': theme.fontWeight.medium,
    'marginRight': theme.margin.s,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  deletedCommentAuthor: {
    color: colors.gray['300'],
    pointerEvents: 'none',
  },
  noComments: {
    marginLeft: theme.margin.s,
  },
}));

export default useCommentSectionStyles;
